import React from "react";
import { clampDims, mediaDimCache, VID_MAX_W, VID_MAX_H, UploadProgress } from "./utils";

export default function VideoMessage({ msg }) {
  const url = msg.file?.url || msg.attach?.url || "";
  if (!url) return null;

  const coverUrl = msg.file?.cover || msg.attach?.cover || msg.attach?.thumb || "";
  const videoSrc = url.includes("#") ? url : url + "#t=0.001";
  const isUploading = msg.uploadProgress !== undefined && msg.uploadProgress < 100;
  const progress = msg.uploadProgress ?? 0;
  const previewPoster = msg.previewImg || coverUrl || undefined;
  const vNatural =
    clampDims(msg.file?.w || msg.attach?.w, msg.file?.h || msg.attach?.h, VID_MAX_W, VID_MAX_H) ||
    mediaDimCache.get(msg.idClient + "_v");
  const vSize = vNatural || { w: 200, h: 113 };

  const handlePlay = (e) => {
    if (e.currentTarget.closest(".imc-msg-pressable")?._longPressed) return;
    const video = e.currentTarget.querySelector("video");
    if (!video) return;
    if (video.requestFullscreen) {
      video.requestFullscreen();
    } else if (video.webkitRequestFullscreen) {
      video.webkitRequestFullscreen();
    } else if (video.webkitEnterFullscreen) {
      video.webkitEnterFullscreen();
    }
    video.play();
  };

  return (
    <div
      className="imc-bubble-media"
      style={{ width: vSize.w, height: vSize.h }}
      onClick={isUploading ? undefined : handlePlay}
    >
      {isUploading ? (
        <img
          src={previewPoster}
          alt="视频"
          style={{ width: vSize.w, height: vSize.h, objectFit: "cover", display: "block", opacity: 0.55 }}
        />
      ) : (
        <video
          src={videoSrc}
          className="imc-msg-video"
          style={{ width: vSize.w, height: vSize.h }}
          playsInline
          preload="metadata"
          poster={previewPoster}
          onLoadedMetadata={(e) => {
            const { videoWidth: vw, videoHeight: vh } = e.currentTarget;
            const d = clampDims(vw, vh, VID_MAX_W, VID_MAX_H);
            if (d) mediaDimCache.set(msg.idClient + "_v", d);
          }}
        />
      )}
      {isUploading ? (
        <UploadProgress progress={progress} />
      ) : (
        <div className="imc-video-play-btn">
          <svg viewBox="0 0 24 24" width="32" height="32" fill="white">
            <circle cx="12" cy="12" r="12" fill="rgba(0,0,0,0.45)" />
            <polygon points="9.5,7 18,12 9.5,17" fill="white" />
          </svg>
        </div>
      )}
    </div>
  );
}
